import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalIconType } from '../../../enums/modal-icon-type';
import { LynxAuthService } from '../../../services/auth.service';
import { LynxLocalizeRouterService } from '../../../services/localize-router.service';
import { LynxModalService } from '../../../services/modal.service';

@Component({
    selector: 'lynx-auth-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class AuthLogoutComponent {
  constructor(
    private modalService: LynxModalService,
    private router: Router,
    private authService: LynxAuthService,
    private localizeRouterService: LynxLocalizeRouterService
  ) {}

  confirmLogout() {
    this.modalService.dispatch({
      icon: ModalIconType.LEAVE,
      title: 'Auth.Logout.Title',
      button: {
        text: 'Auth.Logout.Button.Confirm',
        action: this.logout.bind(this),
        id: 'Logout',
      },
    });
  }

  logout() {
    this.authService.logout().subscribe((_) => {
      this.localizeRouterService.translateRoute('login');
    });
  }
}
